export default [
  {
    path: 'pixel/share-pixel',
    name: 'website.pixel.sharePixel',
    component: () => import('@/views/website/pixel/share-pixel'),
  },
];
